module.exports = __webpack_public_path__ + "static/media/selectedRightnew.84114048.svg";